<div class="card-body">
    {{'Systemreports.customreports.desctext'|translate}}
</div>
<div class="card-footer text-right">
    <button (click)="exportCSV()" class="btn btn-default" aria-label="Download"><br>
        <fa-icon [icon]="faDownload" class="fa-2x"></fa-icon>
    </button>
</div>